// extracted by mini-css-extract-plugin
export default {"filters":"oZnby0Dz1mdWrxlaWPqo-style-filters"};